var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "#ffffff"
    },
    d: "M341.333,10.667H96c-11.782,0-21.333,9.551-21.333,21.333v448c0,11.782,9.551,21.333,21.333,21.333  h320c11.782,0,21.333-9.551,21.333-21.333V106.667L341.333,10.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78B9EB"
    },
    d: "M362.667,106.667h74.667l-96-96v74.667C341.333,97.115,350.885,106.667,362.667,106.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78B9EB"
    },
    d: "M334.869,245.44c-12.904-38.609-49.224-64.499-89.931-64.107 c-50.983-0.88-93.052,39.686-94.027,90.667c0,2.133,0.117,4.267,0.224,6.4c-25.457,4.473-44.131,26.422-44.469,52.267 c0.584,29.983,25.322,53.839,55.307,53.333h171.456c1.888,0,3.659-0.107,5.536-0.213c38.195-1.397,68.026-33.494,66.629-71.689 C404.21,274.278,372.704,244.584,334.869,245.44L334.869,245.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E81CE"
    },
    d: "M447.861,105.995c-0.053-0.935-0.236-1.857-0.544-2.741c-0.117-0.341-0.203-0.672-0.352-1.003 c-0.519-1.161-1.242-2.219-2.133-3.125l-96-96c-0.906-0.892-1.965-1.614-3.125-2.133c-0.331-0.149-0.651-0.235-0.992-0.352 c-0.888-0.289-1.809-0.461-2.741-0.512C341.76,0.117,341.557,0,341.333,0H96C78.327,0,64,14.327,64,32l0,0v448 c0,17.673,14.327,32,32,32h320c17.673,0,32-14.327,32-32V106.667C448,106.432,447.883,106.229,447.861,105.995z M411.584,96 h-48.917C356.776,96,352,91.224,352,85.333V36.416L411.584,96z M416,490.667H96c-5.891,0-10.667-4.776-10.667-10.667V32 c0-5.891,4.776-10.667,10.667-10.667h234.667v64c0,17.673,14.327,32,32,32h64V480C426.667,485.891,421.891,490.667,416,490.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E81CE"
    },
    d: "M342.528,235.232c-16.232-39.481-54.905-65.067-97.589-64.565 c-56.172-0.813-102.686,43.431-104.683,99.573C114.07,278.805,96.264,303.117,96,330.667c0.585,35.874,30.098,64.505,65.973,64 h171.456c2.133,0,4.032-0.107,6.304-0.235c44.01-1.956,78.101-39.218,76.145-83.228 C414.092,271.003,382.641,238.428,342.528,235.232L342.528,235.232z M338.261,373.141c-1.643,0.096-3.2,0.192-4.853,0.192H161.973 c-24.094,0.507-44.058-18.574-44.64-42.667c0.361-20.709,15.379-38.243,35.787-41.781c5.279-1.131,8.949-5.937,8.651-11.328 c-0.096-1.845-0.192-3.701-0.192-5.557c0.997-45.08,38.277-80.857,83.36-80c36.007-0.222,68.126,22.597,79.765,56.672 c1.376,4.377,5.396,7.384,9.984,7.467c32.33-0.596,59.023,25.129,59.619,57.46c0.586,31.771-24.277,58.21-56.024,59.575 L338.261,373.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E81CE"
    },
    d: "M128,64h21.333v21.333H128V64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E81CE"
    },
    d: "M170.667,64h42.667v21.333h-42.667V64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E81CE"
    },
    d: "M128,106.667h85.333V128H128V106.667z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.4623555281e8c78fa8f90cdff7036dd8.svg";
export { ForwardRef as ReactComponent };